
import $ from '@/fly'
const subUrlPrefix = 'message'


export function recMsg(userId,pageNum,readed){
  return $.get(subUrlPrefix+'/recMsg?recUserId='+userId+'&pageNum='+pageNum+'&pageSize=50&readed='+readed)
}


export function updateMessage(id){
  return $.put(subUrlPrefix+'?id='+id)
}




